import { passwordReg, numberReg } from 'utils/functions';
import * as Yup from 'yup';

export const user_schema = {
  fullName: '',
  email: '',
  contactNo: '',
  password: '',
};

export const user_validation_schema = Yup.object({
  fullName: Yup
    .string()
    .required('Name is required'),
  email: Yup
    .string()
    .email('Invalid email')
    .required('Email is required'),
  contactNo: Yup
    .string()
    .matches(numberReg, "Please enter valid contact No"),
  password: Yup
    .string()
    .required("Password is required")
    .min(8, 'Password must be at least 8 characters')
    .matches(passwordReg, 'New Password must contain at least one uppercase letter, one lowercase letter, one number and one special character'),
});

export const edit_user_validation_schema = Yup.object({
  fullName: Yup
    .string()
    .required('Name is required'),
  email: Yup
    .string()
    .email('Invalid email')
    .required('Email is required'),
  contactNo: Yup
    .string()
    .matches(numberReg, "Please enter valid contact No"),
});
